// @flow

// - Stylesheet
import './inscription-update.less';

// - Vendors
import { View }   from '@insolus/backbone';
import CakeRoutes from '@insolus/cake-routes';

// - Components
import SelectizeView from 'views/shared/components/selectize';

class InscriptionUpdate extends View {
    get isPrerendered(): boolean { return true; }

    get events(): Object {
        return {
            'change .inscription-update__input--country': 'onCountryChange'
        };
    }

    initialize() {
        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    bindElements() {
        this.$input                 = this.$el.element('input');
        this.$country               = this.$input.modifier('country');
        this.$localityId            = this.$input.modifier('locality-id');
        this.$localityText          = this.$input.modifier('locality-text');
        this.$localityIdContainer   = this.$el.element('locality-id-container');
        this.$localityTextContainer = this.$el.element('locality-text-container');
    }

    onRender() {
        this.contactPersonFieldSelectize = new SelectizeView({
            el           : this.$localityId,
            routeUrl     : CakeRoutes.get('Locality', 'get_list'),
            getUrlParams : (): Object => ({ 'country_id': this.$country.filter(':checked').val() })
        });
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Custom methods
    // —
    // ——————————————————————————————————————————————————————

    onCountryChange() {
        this._clearLocalityInput();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Internal methods
    // —
    // ——————————————————————————————————————————————————————

    _clearLocalityInput() {
        const localitySelectize = this.$localityId[0].selectize;
        localitySelectize.clear();
        localitySelectize.clearOptions();

        if (this.$country.filter(':checked').val() === 'OT') {
            this.$localityTextContainer.removeModifier('hidden');
            this.$localityIdContainer.addModifier('hidden');
            return;
        }

        this.$localityTextContainer.addModifier('hidden');
        this.$localityText.val('');
        this.$localityIdContainer.removeModifier('hidden');
    }
}

export default new InscriptionUpdate('.inscription-update');



// WEBPACK FOOTER //
// ./src/views/themes/front/pages/Pages/inscription_update/inscription-update.js